import { QueryKey, useQuery, UseQueryOptions } from "react-query"
import { useApi } from "../../services/api"
import { deriveLoadingErrorState } from "../utils/utils"
import { getUsersGetAllUrl } from "./userApi"
import { UserSnapshot } from "./userTypes"

type Keys = "allUsers"

export const USER_QUERY_KEYS: Record<Keys, QueryKey> = {
    allUsers: ["allUsers"],
}

export type AllUsersQueryData = { data: UserSnapshot[] }

export function useAllUsersQuery(
    options: Pick<UseQueryOptions, "refetchOnMount"> = {}
) {
    const api = useApi()

    const { isLoading, isError, isRefetching, data } = useQuery(
        USER_QUERY_KEYS.allUsers,
        () => api.get<AllUsersQueryData>(getUsersGetAllUrl())
    )

    return {
        users: data?.data,
        isUsersLoading: isLoading,
        usersErrorState: deriveLoadingErrorState(isError, isRefetching),
        isUsersError: isError,
        isUsersRefetching: isRefetching,
    }
}
